// AbaPaywayIntegration.js
const ClickToPay = require('./ClickToPay');
const { redirectPayFetchForAba } = require('../http');
const { method } = require('../variables');
const { mainConfigService } = require('../services/config');
const { ABA_FORM_CONFIGS } = require('../constants');

class AbaPaywayIntegration extends ClickToPay {
  async initialize() {
    const existingForm = document.getElementById(ABA_FORM_CONFIGS.ID);
    if (existingForm) {
      existingForm.remove();
    }
    const response = await this._performInitialization();

    this.handlePayment(response);
  }

  async _performInitialization() {
    try {
      const response = await this.fetchAbaPaywayForm();

      await this.loadVendorScript(response.js_sdk_src);

      return response;
    } catch (error) {
      console.error('Error initializing Aba Payway integration:', error);
      throw error;
    }
  }

  async fetchAbaPaywayForm() {
    return redirectPayFetchForAba(
      this.submitUrl,
      mainConfigService.get('session_id'),
      method.sub_option_value,
      mainConfigService.get('apiKey'),
      method.code
    );
  }

  async handlePayment({ form_url, form_data, reference_number, ws_url }) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = form_url;
    form.target = ABA_FORM_CONFIGS.TARGET;
    form.style.display = 'none';
    form.id = ABA_FORM_CONFIGS.ID;

    Object.keys(form_data).forEach((key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = form_data[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);

    await this.waitForDependency();
    this.runAbaPaywayCheckout();

    this.fieldsService.disableEnableFields(false);

    await this.handleWebSocket({
      ws_url: ws_url,
      reference_number: reference_number,
    });
  }

  runAbaPaywayCheckout() {
    AbaPayway.checkout();
  }

  checkDependency() {
    return (
      typeof AbaPayway !== 'undefined' &&
      typeof AbaPayway.checkout === 'function'
    );
  }
}

module.exports = AbaPaywayIntegration;
